import { Store } from '@ngxs/store';
import { PDFDocument, StandardFonts } from 'pdf-lib';
import { Injectable } from '@angular/core';

@Injectable()
export class PioneerRxConsentFormPdfService {
    consentFormWithInitialDataBytes: Uint8Array;
    signedFormBytes: Uint8Array;

    constructor(private store: Store) {
    } 

    async addStaticInformation(pharmacyName: string, npi: string, address: string, date: string): Promise<Blob> {
        const pdfDoc = await this.loadDoc();
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const courierBold = await pdfDoc.embedFont(StandardFonts.CourierBold);
        const { width, height } = firstPage.getSize();
        const fontSize = 10;
        firstPage.drawText('C2 Keep', 
        { 
             x: 300,
             y: height - 170,
             size: fontSize,
             font: courierBold
         })

         firstPage.drawText('Real-time', 
         { 
              x: 298,
              y: height - 190,
              size: fontSize,
              font: courierBold
          })

          firstPage.drawText(pharmacyName, {
            x: 160,
            y: height - 229,
            size: fontSize,
            font: courierBold,
          });

          firstPage.drawText(npi, {
            x: 183,
            y: height - 249,
            size: fontSize,
            font: courierBold,
          });

          firstPage.drawText(address, {
            x: 175,
            y: height - 267,
            size: fontSize,
            font: courierBold,
          });

          pages[1].drawText(date, {
            x: 473,
            y: height - 603,
            size: fontSize,
            font: courierBold,
          });

         const pdfBytes = await pdfDoc.save();
         this.consentFormWithInitialDataBytes = pdfBytes;

         return new Blob([pdfBytes], { type: 'application/pdf' });
    }

    async addSignature(signature: string): Promise<Blob> {
      const pdfDoc = await this.loadPopulatedDoc(this.consentFormWithInitialDataBytes) || await this.loadDoc();
      const pages = pdfDoc.getPages();
      const lastPage = pages[1];
      const image = await pdfDoc.embedPng(signature);

        lastPage.drawImage(image, 
        { 
             x: 145,
             y: lastPage.getSize().height - 610,
             width: 150,
             height: 100
         })
         
         const pdfBytes = await pdfDoc.save();
         this.signedFormBytes = pdfBytes;

         return new Blob([pdfBytes], { type: 'application/pdf' });
    }

    async addName(firstName: string, lastName: string): Promise<Blob> {
      const pdfDoc = await this.loadPopulatedDoc(this.signedFormBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const courierBold = await pdfDoc.embedFont(StandardFonts.CourierBold);
      const fontSize = 10;

      firstPage.drawText(`${firstName} ${lastName}`, {
        x: 143,
        y: firstPage.getSize().height - 306,
        size: fontSize,
        font: courierBold,
      });
      const pdfBytes = await pdfDoc.save();
      return new Blob([pdfBytes], { type: 'application/pdf' });
    }


    private async loadDoc(): Promise<PDFDocument> {
       const existingPdfBytes = await fetch('assets/documents/Pioneer Integration Customer Request Form.pdf').then(file => file.arrayBuffer());
       const pdfDoc = await PDFDocument.load(existingPdfBytes)
       return pdfDoc;
    }

    private async loadPopulatedDoc(bytes: Uint8Array): Promise<PDFDocument> {
      const pdfDoc = await PDFDocument.load(bytes)
      return pdfDoc;
    }

}